import React from "react";
import { useSelector } from "react-redux";
import MedicationChecklist from "../../service-steps/medication/medications-checklist";
import Goals from "../../service-steps/treatment/goals";
import MedicationsReview from "../../service-steps/medication/medications-review";

const ReviewMedication = () => {
  const { clinicalServiceObj } = useSelector((state) => state.clinicalService);
  const { currentSubStep } =
    clinicalServiceObj.initialAssessment.initialAssessmentForm;

  const renderStep = () => {
    const subStep = currentSubStep;
    switch (subStep) {
      case 1:
        return <Goals />;
      case 2:
        return <MedicationsReview />;
      case 3:
        return <MedicationChecklist />;
    }
  };
  return renderStep();
};

export default ReviewMedication;
